import React, { useState, useEffect,useContext } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "../api/axiosInstance";
import {
  FaUser,
  FaIdCard,
  FaPhone,
  FaStore,
  FaMapMarkerAlt,
  FaCity,
  FaGlobe,
  FaMobile,
} from "react-icons/fa";
import { CustomerContext } from "../context/customerContext";

// تنظیم آیکون پیش‌فرض Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const CustomerInfo = () => {
  const navigate = useNavigate();
  // const [customerBase, setCustomerBase] = useState(null); // اطلاعات customer
  const { customer: customerBase } = useContext(CustomerContext);
  const [addresses, setAddresses] = useState([]); // اطلاعات customerAddress


  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const token = localStorage.getItem("token");

        // const baseRes = await axios.get(
        //   "/Customer/CustomerInfo");
        // setCustomerBase(baseRes.data);

        const addrRes = await axios.get(
          "/Customer/CustomerDetail" );

        if (Array.isArray(addrRes.data)) {
          setAddresses(addrRes.data);
        }
      } catch (error) {
        console.error("❌ خطا در گرفتن اطلاعات مشتری:", error);
      }
    };

    fetchCustomerData();
  }, []);

  const mainAddress = addresses.find((addr) => addr.isMainAddress);
  const latitude = Number(mainAddress?.latitude);
  const longitude = Number(mainAddress?.longitude);

  if (!customerBase) {
    return (
      <div className="p-6 text-gray-600 font-bold text-center">
        در حال دریافت اطلاعات مشتری...
      </div>
    );
  }
  return (
    <DashboardLayout customer={customerBase}>
      <div className="py-3 flex flex-col gap-5" dir="rtl">
        {/* هدر صفحه */}
        <div className="w-full flex justify-between items-center">
          <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
            اطلاعات مشتری
          </h1>
          <button
            onClick={() => navigate(-1)}
            className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
          >
            بازگشت
          </button>
        </div>
  
        {/* کارت اطلاعات */}
        <div className="w-full bg-white/70 backdrop-blur-md rounded-xl shadow-md p-6 space-y-4 text-base text-right">
          <div className="flex items-center gap-2">
            <FaUser className="text-blue-800" />
            <span><strong>نام:</strong> {customerBase.customerName}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaIdCard className="text-blue-800" />
            <span><strong>کد مشتری:</strong> {customerBase.customerCode}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaMobile className="text-blue-800" />
            <span><strong>موبایل:</strong> {customerBase?.mobile || "نامشخص"}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaPhone className="text-blue-800" />
            <span><strong>تلفن:</strong> {addresses[0]?.phone || "نامشخص"}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaStore className="text-blue-800" />
            <span><strong>نام فروشگاه:</strong> {addresses[0]?.storeName}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaGlobe className="text-blue-800" />
            <span><strong>استان:</strong> {addresses[0]?.province}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaCity className="text-blue-800" />
            <span><strong>شهر:</strong> {addresses[0]?.city}</span>
          </div>
  
          {addresses.map((addr, i) => (
            <div key={i} className="flex items-center gap-2">
              <FaMapMarkerAlt className="text-blue-800" />
              <span><strong>آدرس {i + 1}:</strong> {addr.addressDetails}</span>
            </div>
          ))}
        </div>
  
        {/* نقشه */}
        {mainAddress && latitude && longitude ? (
          <div className="w-full h-80 rounded-xl overflow-hidden shadow-md">
            <MapContainer
              center={[latitude, longitude]}
              zoom={14}
              scrollWheelZoom
              className="h-full w-full"
            >
              <TileLayer
                attribution='&copy; <a href="https://osm.org">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[latitude, longitude]}>
                <Popup>{mainAddress.storeName || "موقعیت مشتری"}</Popup>
              </Marker>
            </MapContainer>
          </div>
        ) : (
          <div className="text-sm text-gray-600 font-semibold">
            موقعیت جغرافیایی برای شما ثبت نشده است.
          </div>
        )}
      </div>
    </DashboardLayout>
  );
  
};

export default CustomerInfo;
